import { HttpAuthRepository } from '@/modules/auth/infrastructure/repositories/HttpAuthRepository';

const OAUTH_STATE_STORAGE_KEY = 'oauth_state';
const OAUTH_REDIRECT_STORAGE_KEY = 'auth_redirect_after_login';
let inFlightOAuthLogin: Promise<void> | null = null;

function getOAuthStateFromRedirectUrl(redirectUrl: string): string | null {
  try {
    const baseUrl = typeof window !== 'undefined' ? window.location.origin : 'http://localhost';
    const url = new URL(redirectUrl, baseUrl);
    const state = url.searchParams.get('state');
    return state && state.length > 0 ? state : null;
  } catch {
    return null;
  }
}

async function doStartOAuthLogin(redirectPath?: string): Promise<void> {
  if (redirectPath) {
    sessionStorage.setItem(OAUTH_REDIRECT_STORAGE_KEY, redirectPath);
  }

  const repo = new HttpAuthRepository();
  const response = await repo.getOAuthRedirectUrl();
  const oauthState = response.state ?? getOAuthStateFromRedirectUrl(response.redirect_url);

  if (oauthState) {
    sessionStorage.setItem(OAUTH_STATE_STORAGE_KEY, oauthState);
  }

  window.location.assign(response.redirect_url);
}

export async function startOAuthLogin(redirectPath?: string): Promise<void> {
  if (typeof window === 'undefined') {
    return;
  }

  if (inFlightOAuthLogin) {
    return inFlightOAuthLogin;
  }

  const attempt = doStartOAuthLogin(redirectPath);
  inFlightOAuthLogin = attempt;
  try {
    await attempt;
  } catch (error) {
    inFlightOAuthLogin = null;
    throw error;
  }
}
